// Contenido real del Centro Veterinario Los Orientales (según documento del cliente).
// Nombres del equipo, bios y testimonios son contenido de ejemplo, reemplazables.

export const CLINIC = {
  name: "Centro Veterinario Los Orientales",
  short: "Los Orientales",
  tagline: "Medicina integral de perros y gatos en Ñuñoa",
  commune: "Ñuñoa, Santiago",
  address: "Alcalde Eduardo Castillo Velasco 5448, Ñuñoa, Santiago",
  phone: "+562 2272 2200",
  phoneHref: "+56222722200",
  whatsapp: "+569 7876 4739",
  whatsappDigits: "56978764739",
  email: "vetlosorientales@gmail.com",
  website: "www.vetlosorientales.cl",
  websiteHref: "https://www.vetlosorientales.cl",
  instagram: "@vetlosorientales",
  instagramHref: "https://instagram.com/vetlosorientales",
  hours: "Lunes a sábado: 10:00 a 20:00 hrs",
  hoursShort: "10:00 – 20:00 horas",
  mapsQuery: "Alcalde Eduardo Castillo Velasco 5448, Ñuñoa, Santiago, Chile",
};

export const WHATSAPP_MSG = encodeURIComponent(
  "¡Hola! Quiero agendar una hora en Centro Veterinario Los Orientales 🐾"
);

export const waLink = () =>
  `https://wa.me/${CLINIC.whatsappDigits}?text=${WHATSAPP_MSG}`;

export const mapsEmbed = () =>
  `https://maps.google.com/maps?q=${encodeURIComponent(CLINIC.mapsQuery)}&t=&z=16&ie=UTF8&iwloc=&output=embed`;

export const SERVICES = [
  {
    id: "medicina-general",
    title: "Medicina General",
    icon: "Stethoscope",
    description:
      "Consultas integrales, chequeos preventivos, vacunas y desparasitación adaptadas a cada paciente.",
  },
  {
    id: "cirugia-general",
    title: "Cirugía",
    icon: "Scissors",
    description: "Esterilizaciones, castraciones, tumores, heridas y cirugías en general.",
  },
  {
    id: "gastroenterologia",
    title: "Gastroenterología",
    icon: "Activity",
    description:
      "Diagnóstico y tratamiento especializado de patologías digestivas, intolerancias, cuadros agudos y crónicos.",
  },
  {
    id: "telemedicina",
    title: "Consulta Online a todo Chile",
    icon: "Video",
    highlight: "Nacional",
    description:
      "Consultas online a toda el área metropolitana y de Arica a Punta Arenas. Orientación experta, revisión de exámenes y despacho de recetas.",
  },
  {
    id: "ecografias",
    title: "Ecografías",
    icon: "ScanLine",
    description:
      "Ultrasonografía diagnóstica no invasiva de alta resolución para evaluación abdominal, gestacional y ocular.",
  },
  {
    id: "laboratorio-clinico",
    title: "Laboratorio Clínico",
    icon: "FlaskConical",
    description:
      "Exámenes de sangre, orina y piel. Biopsias y exámenes citológicos, con resultados rápidos y confiables.",
  },
  {
    id: "limpieza-dental",
    title: "Limpieza Dental",
    icon: "Sparkles",
    description:
      "Con ultrasonido y tratamiento periodontal integral para controlar infecciones y el mal aliento.",
  },
];

export const TELEMEDICINA = {
  title: "Consulta Online Veterinaria a todo Chile",
  subtitle:
    "Consulta online a toda la región metropolitana y a todo el país.",
  features: [
    "Consultas online con especialista en Gastroenterología.",
    "Órdenes de exámenes y despacho de recetas.",
    "Indicaciones de nutrición y seguimiento de casos.",
    "Disponibilidad para toda el área metropolitana y el resto del país.",
  ],
};

export const TEAM = [
  {
    name: "Dra. Camila Morales",
    role: "Directora Médica · Medicina Felina",
    bio: "Médica Veterinaria con más de 12 años de experiencia, apasionada por el bienestar felino y la medicina preventiva.",
    photo:
      "https://images.unsplash.com/photo-1594824476967-48c8b964273f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Dr. Mateo Fuenzalida",
    role: "Cirujano General · Gastroenterología",
    bio: "Especializado en cuadros digestivos complejos y procedimientos quirúrgicos de baja invasión.",
    photo:
      "https://images.unsplash.com/photo-1622253692010-333f2da6031d?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    name: "Dr. Tomás Herrera",
    role: "Medicina General · Urgencias",
    bio: "Enfocado en una atención cercana y empática, acompañando a cada familia y su mascota en todo el proceso.",
    photo:
      "https://images.unsplash.com/photo-1730597842283-943c7986ee2c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Llevo a mi gata Luna desde que era cachorra. La paciencia y empatía del equipo en Ñuñoa es inigualable.",
    author: "Valentina R.",
    pet: "Tutora de Luna (Gata)",
  },
  {
    quote:
      "Hicimos una teleconsulta desde Valdivia por el problema estomacal de Bruno. Nos salvaron el fin de semana.",
    author: "Gonzalo M.",
    pet: "Tutor de Bruno (Golden Retriever)",
  },
  {
    quote:
      "La limpieza dental de mi perro quedó impecable y el trato postoperatorio fue súper cariñoso. Recomendados.",
    author: "Isadora P.",
    pet: "Tutora de Copito (Poodle)",
  },
];

export const IMAGES = {
  heroWarm:
    "https://images.unsplash.com/photo-1579119134757-5c38803f34fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  heroModern:
    "https://images.unsplash.com/photo-1700665537650-1bf37979aae0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  heroClean:
    "https://images.unsplash.com/photo-1725409796872-8b41e8eca929?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  vetDog:
    "https://images.unsplash.com/photo-1700665537650-1bf37979aae0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  vetCat:
    "https://images.unsplash.com/photo-1725409796872-8b41e8eca929?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  ownerHug:
    "https://images.unsplash.com/photo-1522276498395-f4f68f7f8454?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  womanDog:
    "https://images.unsplash.com/photo-1557495235-340eb888a9fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  dogCat:
    "https://images.unsplash.com/photo-1450778869180-41d0601e046e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  catAffection:
    "https://images.unsplash.com/photo-1596272875729-ed2ff7d6d9c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  telemed:
    "https://images.unsplash.com/photo-1644675272883-0c4d582528d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  metro:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_proposal-generator-39/artifacts/e2e8b307e122085d_image.png",
};
